/***
 * @Author: ZhaoG
 * @Date: 2025-04-23 15:52:22
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-04-29 17:47:54
 * @FilePath: \gcp-fe\src\basa\router\modules\shopping.js
 * @Description:路由配置文
 */
import Layout from "@/app/common-modules/layout/Layout";
const shoppingRouter = [
  {
    path: "",
    component: Layout,
    redirect: "",
    children: [
      {
        path: "",
        component: () => import("@/app/shop/views/shopping.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "shopping"
      },
      {
        path: "/procurementNotice",
        component: () =>
          import("@/app/procurementNotice/views/procurementNotice.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "procurementNotice"
      },
      // 联系我们
      {
        path: "/contactUs",
        component: () => import("@/app/contactUs/views/index.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "contactUs"
      },
      // 操作指引
      {
        path: "/operationGuide",
        component: () => import("@/app/contactUs/views/operationGuide.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "operationGuide"
      },
      // 入网须知
      {
        path: "/networkAccessNotice",
        component: () =>
          import("@/app/contactUs/views/networkAccessNotice.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "networkAccessNotice"
      },
      // 平台简介
      {
        path: "/platformIntroduction",
        component: () =>
          import("@/app/shop/components/platformIntroduction.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "platformIntroduction"
      },
      {
        path: "/noticeList",
        component: () => import("@/app/noticesList/views/index.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "noticeList"
      },
      {
        // 分包商 找回密码
        path: "/subFindPassword",
        component: () => import("@/app/shop/views/subFindPassword.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "subFindPassword"
      },
      {
        // 管控名单或黑名单申诉
        path: "/subAppeal",
        component: () => import("@/app/shop/views/subAppeal.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "subAppeal"
      },
      {
        // 供应商 找回密码采购
        path: "/findPassword",
        component: () => import("@/app/shop/views/findPassword.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "findPassword"
      },
      {
        path: "/noticeDetail",
        component: () => import("@/app/noticesList/views/detail.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "noticeDetail"
      },
      {
        path: "/searchList",
        component: () =>
          import("@/app/procurementNotice/views/procurementNotice.vue"),
        // component: () => import("@/app/shop/views/searchList.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "searchList"
      },
      {
        path: "/viewNoticeDetailNew",
        component: () => import("@/app/shop/views/viewNoticeDetailNew.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "viewNoticeDetailNew"
      },
      {
        path: "/viewNoticeDetail",
        component: () => import("@/app/shop/views/viewNoticeDetail.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "viewNoticeDetail"
      },
      {
        path: "/fenBaoDetail",
        component: () => import("@/app/shop/components/fenBaoDetail.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "fenBaoDetail"
      },
      {
        path: "/viewNoticeSimpleDetail",
        component: () => import("@/app/shop/views/viewNoticeSimpleDetail.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "viewNoticeSimpleDetail"
      },
      {
        path: "/viewNoticeSimpleDetailFB",
        component: () =>
          import("@/app/shop/views/viewNoticeSimpleDetailFB.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "viewNoticeSimpleDetailFB"
      },
      {
        path: "/announcementsList",
        component: () => import("@/app/shop/views/announcementsList.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "announcementsList"
      },
      {
        path: "/announcementDetail",
        component: () => import("@/app/shop/views/announcementDetail.vue"),
        meta: {
          isShowShopHead: true,
          isShowPageFooter: true //是否展示页脚
        },
        name: "announcementDetail"
      }
    ]
  }
];

export default shoppingRouter;
